import React from "react";
import styled from "styled-components";

import { CRITICALITY_FILTERS } from "./criticalityFilters";

/** One chip per criticality filter with how many rows it holds, each level's with its colour dot; the selected one filled. */
export default function CriticalityFilters({ counts, selected, onSelect }) {
    return (
        <Row role="group" aria-label="Criticality">
            {CRITICALITY_FILTERS.map(({ key, label, color }) => (
                <Chip key={key} type="button" aria-pressed={key === selected} $selected={key === selected} onClick={() => onSelect(key)}>
                    {color && <Dot $color={color} />}
                    {label}
                    <Count>{counts[key].toLocaleString()}</Count>
                </Chip>
            ))}
        </Row>
    );
}

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 0 0 10px;
    @media (max-width: 600px) { padding: 0 16px; }
`;

const Chip = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 34px;
    padding: 0 12px;
    border-radius: 999px;
    border: 1px solid ${({ $selected }) => ($selected ? "#0f172a" : "#e2e8f0")};
    background: ${({ $selected }) => ($selected ? "#0f172a" : "#fff")};
    color: ${({ $selected }) => ($selected ? "#fff" : "#0f172a")};
    font: inherit;
    font-size: 13px;
    cursor: pointer;
    &:hover { border-color: ${({ $selected }) => ($selected ? "#0f172a" : "#94a3b8")}; }
`;

const Dot = styled.span`
    width: 6px;
    height: 6px;
    border-radius: 999px;
    flex-shrink: 0;
    background: ${({ $color }) => $color};
`;

const Count = styled.span`
    font-variant-numeric: tabular-nums;
    opacity: 0.7;
`;
